import { AudienceCreatePresenter } from '@/components/audiences/audience-create.presenter';
import { useEditAudiencePage } from '@/components/audiences/use-edit-audience-page';
import { useI18nContext } from '@/i18n/i18n-react';
import {
  CenteredContent,
  CenteredContentLayout,
  Header,
} from '@/layouts/centered-content.layout';
import { SidebarLayout } from '@/layouts/sidebar.layout';
import { PageBreadcrumb } from '@/components/page-breadcrumb';

export default function EditAudienceAdvancedPage() {
  const edit = useEditAudiencePage();
  const { LL } = useI18nContext();

  if (edit.isLoadingAudience) {
    return (
      <SidebarLayout className="!p-0">
        <CenteredContentLayout>
          <Header className="flex justify-between w-full" rightGutter>
            <PageBreadcrumb
              items={[
                {
                  label: LL.audiences.title(),
                  href: `/${edit.tenantSlug}/audiences`,
                },
                { label: LL.audiences.edit.breadcrumbLabel() },
              ]}
            />
          </Header>
          <CenteredContent>
            <div className="py-10 text-center">
              <p className="text-muted-foreground">
                {LL.audiences.loadingAudience()}
              </p>
            </div>
          </CenteredContent>
        </CenteredContentLayout>
      </SidebarLayout>
    );
  }

  if (edit.isAudienceError) {
    return (
      <SidebarLayout className="!p-0">
        <CenteredContentLayout>
          <Header className="flex justify-between w-full" rightGutter>
            <PageBreadcrumb
              items={[
                {
                  label: LL.audiences.title(),
                  href: `/${edit.tenantSlug}/audiences`,
                },
                { label: LL.audiences.edit.breadcrumbLabel() },
              ]}
            />
          </Header>
          <CenteredContent>
            <div className="py-10 text-center">
              <p className="text-muted-foreground">
                {LL.audiences.failedToLoadAudience()}
              </p>
            </div>
          </CenteredContent>
        </CenteredContentLayout>
      </SidebarLayout>
    );
  }

  return (
    <AudienceCreatePresenter
      {...edit}
      audienceId={edit.audienceId}
      isSaveNameDialogOpen={false}
      onSaveNameDialogOpenChange={() => {}}
      saveNameDialogName=""
      onSaveNameConfirm={() => {}}
    />
  );
}
